import { createFileRoute } from "@tanstack/react-router";
import { EndBookingCrisis } from "@/components/press/articles/EndBookingCrisis";

const SITE = "https://heallexa.com";
const URL = `${SITE}/press/end-healthcare-booking-crisis`;
const TITLE =
  "How Heallexa is Using WhatsApp and SMS to End the Healthcare Booking Crisis";
const DESCRIPTION =
  "Heallexa launches with 6.3 million provider records, deploying conversational AI on WhatsApp, SMS, and voice to replace legacy doctor portals with text-message scheduling.";
const DATE_ISO = "2026-06-08";

export const Route = createFileRoute("/press/end-healthcare-booking-crisis")({
  head: () => ({
    meta: [
      { title: `${TITLE} | Heallexa` },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      { property: "article:published_time", content: DATE_ISO },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "NewsArticle",
          headline: TITLE,
          description: DESCRIPTION,
          datePublished: DATE_ISO,
          dateModified: DATE_ISO,
          url: URL,
          author: { "@type": "Organization", name: "Heallexa", url: SITE },
          publisher: {
            "@type": "Organization",
            name: "Heallexa",
            logo: { "@type": "ImageObject", url: `${SITE}/logo.png` },
          },
          mainEntityOfPage: { "@type": "WebPage", "@id": URL },
        }),
      },
    ],
  }),
  component: EndBookingCrisis,
});
